import React, { useEffect, useState, useRef } from 'react';
import HomeModel from '../../models/HomeModel';
import { Link, useLocation } from 'react-router-dom';
import AuthMoldel from '../../models/AuthMoldel';
import ModalPackageWarning from './ModalPackageWarning';
import { 
    RiAdminLine, 
    RiLogoutBoxRLine, 
    RiArrowDownSLine, 
    RiVipCrown2Fill,
    RiShieldCheckLine,
    RiSunLine,
    RiMoonLine
} from 'react-icons/ri';

function Header() {
    const [modalShow, setModalShow] = useState(false);
    const [data, setData] = useState({});
    const [packageExpired, setPackageExpired] = useState([]);
    const [isShow, setIsShow] = useState(false);
    const [themeMode, setThemeMode] = useState(() => {
        try {
            const saved = localStorage.getItem('wus_theme_mode');
            return saved === 'dark' || saved === 'light' ? saved : 'dark';
        } catch (e) {
            return 'dark';
        }
    });
    const dropdownRef = useRef(null);
    const location = useLocation();
    const isAdmin = AuthMoldel.isAdmin();

    const applyThemeMode = (mode) => {
        try {
            localStorage.setItem('wus_theme_mode', mode);
        } catch (e) {}
        document.documentElement.setAttribute('data-theme-mode', mode);
        if (document.body) {
            document.body.setAttribute('data-theme-mode', mode);
        }
        const meta = document.getElementById('wus-theme-color-meta');
        if (meta) {
            meta.setAttribute('content', mode === 'dark' ? '#09090b' : '#fafafa');
        }
        setThemeMode(mode);
        window.dispatchEvent(new CustomEvent('theme-mode-changed', { detail: mode }));
    };

    const handleToggleTheme = () => {
        const nextMode = themeMode === 'light' ? 'dark' : 'light';
        applyThemeMode(nextMode);
    };

    useEffect(() => {
        applyThemeMode(themeMode);
        const onExternalThemeChange = (e) => {
            if (e.detail && (e.detail === 'light' || e.detail === 'dark')) {
                setThemeMode(e.detail);
            }
        };
        window.addEventListener('theme-mode-changed', onExternalThemeChange);
        return () => window.removeEventListener('theme-mode-changed', onExternalThemeChange);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClick = () => {
        setIsShow(!isShow);
    };

    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsShow(false);
            }
        };
        document.addEventListener('mousedown', handleOutsideClick);
        return () => document.removeEventListener('mousedown', handleOutsideClick);
    }, []);

    useEffect(() => {
        const fetchHeader = () => {
            HomeModel.getInfoHeader().then((res) => {
                setData(res.data || {});
            }).catch(() => {});
        };
        fetchHeader();
        window.addEventListener('user-data-updated', fetchHeader);
        return () => window.removeEventListener('user-data-updated', fetchHeader);
    }, [location.pathname]);

    useEffect(() => {
        HomeModel.checkPackageExpired().then((res) => {
            if (res.is_expired) {
                setModalShow(true);
                setPackageExpired(res.data);
            }
        }).catch(() => {});
    }, []);

    const handleClickRemoveLocalStorage = () => {
        localStorage.removeItem("imageQR");
        localStorage.removeItem("imageQrTPB");
    };

    const getPageTitle = () => {
        const path = location.pathname;
        if (path.includes('/payment/deposit')) return 'Nạp Tiền & Kích Hoạt Giftcode';
        if (path.includes('/transaction/history')) return 'Lịch Sử Chi Tiêu & Giao Dịch';
        if (path.includes('/admin')) return 'Hệ Thống Quản Trị Admin';
        return 'Bảng Điều Khiển Ngân Hàng Ảo';
    };

    const userInitial = (data.name || data.user_name || 'U').charAt(0).toUpperCase();

    return (
        <div>
            <div className="header mobile-header">
                <div className="header-content">
                    <nav className="navbar navbar-expand w-100">
                        <div className="d-flex align-items-center justify-content-between w-100">
                            {/* Left Context Breadcrumb (Desktop) */}
                            <div className="header-page-context d-none d-md-flex align-items-center gap-2">
                                <span className="header-context-dot"></span>
                                <span className="header-context-title">{getPageTitle()}</span>
                            </div>

                            {/* Right Actions: Theme Switcher & User Profile Capsule */}
                            <div className="ms-auto d-flex align-items-center" style={{ gap: '6px' }}>
                                <button
                                    type="button"
                                    className="wus-theme-toggle-btn"
                                    onClick={handleToggleTheme}
                                    title={themeMode === 'light' ? 'Chuyển sang Giao diện Tối (Dark Mode)' : 'Chuyển sang Giao diện Sáng (Light Mode)'}
                                    aria-label="Chuyển đổi giao diện Sáng/Tối"
                                >
                                    {themeMode === 'light' ? (
                                        <>
                                            <RiMoonLine size={15} />
                                            <span className="wus-theme-toggle-label">Giao diện Tối</span>
                                        </>
                                    ) : (
                                        <>
                                            <RiSunLine size={15} />
                                            <span className="wus-theme-toggle-label">Giao diện Sáng</span>
                                        </>
                                    )}
                                </button>

                                <div className="dropdown header-profile2" ref={dropdownRef}>
                                    <button
                                        type="button"
                                        className="wus-user-capsule"
                                        onClick={handleClick}
                                    >
                                        <div className="wus-avatar-circle">
                                            {userInitial}
                                        </div>
                                        <div className="wus-user-meta text-start">
                                            <div className="d-flex align-items-center gap-1">
                                                <span className="wus-user-name">
                                                    {data.name || data.user_name || 'Người dùng'}
                                                </span>
                                                {data.combo_days > 0 && (
                                                    <span className="wus-user-vip-chip">
                                                        <RiVipCrown2Fill size={10} /> VIP
                                                    </span>
                                                )}
                                            </div>
                                            <span className="wus-user-role">
                                                {data.role === 0 ? 'Quản trị viên' : 'Thành viên chính thức'}
                                            </span>
                                        </div>
                                        <RiArrowDownSLine
                                            size={16}
                                            className={`wus-user-caret ${isShow ? 'rotated' : ''}`}
                                        />
                                    </button>

                                    <div
                                        className={`dropdown-menu profile dropdown-menu-end ${isShow ? 'show' : ''}`}
                                        data-bs-popper="none"
                                    >
                                        <div className="px-3 py-2 mb-1" style={{ borderBottom: '1px solid var(--wus-border)' }}>
                                            <div style={{ fontSize: '12px', fontWeight: 600, color: 'var(--wus-text)' }}>
                                                {data.name || data.user_name || 'Tài khoản'}
                                            </div>
                                            <div style={{ fontSize: '11px', color: 'var(--wus-text-subtle)', display: 'flex', alignItems: 'center', gap: '4px', marginTop: '2px' }}>
                                                <RiShieldCheckLine size={12} style={{ color: 'var(--wus-success)' }} />
                                                <span>Đã xác thực bảo mật</span>
                                            </div>
                                        </div>
                                        {isAdmin && (
                                            <Link to={'/admin'} className="dropdown-item ai-icon" onClick={() => setIsShow(false)}>
                                                <RiAdminLine size={15} style={{ color: 'var(--wus-text-muted)' }} />
                                                <span>Trang quản trị</span>
                                            </Link>
                                        )}
                                        <Link
                                            to={'/logout'}
                                            onClick={handleClickRemoveLocalStorage}
                                            className="dropdown-item ai-icon"
                                            style={{ color: "var(--wus-danger-text)" }}
                                        >
                                            <RiLogoutBoxRLine size={15} style={{ color: "var(--wus-danger-text)" }} />
                                            <span>Đăng xuất tài khoản</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
            <ModalPackageWarning
                show={modalShow}
                packageExpired={packageExpired}
                onHide={() => setModalShow(false)}
            />
        </div>
    );
}

export default Header;
